import {
  MDSButton,
  MDSButtonVariant,
  MDSButtonSlotName,
  MDSIcon,
  MDSIconKind,
  MDSButtonSize,
  MDSTooltip,
  MDSTooltipPlacement,
} from "@/mds";
import { INoteObservable } from "@/store/note";
import { observer } from "mobx-react-lite";
import { getShortcutTooltipConfig } from "@/modules/keyboard-shortcuts/tooltip";

type Props = {
  note: INoteObservable;
  onToggleOrganizeIsOpen: () => void;
  renderTrigger?: (trigger: React.ReactNode) => React.ReactNode;
};

export const OrganizeNoCollections = observer(
  ({ note, onToggleOrganizeIsOpen, renderTrigger }: Props) => {
    const organizeButton = (
      <MDSTooltip
        config={getShortcutTooltipConfig({
          action: "organize_selected_notes",
          label: "Organize",
          placement: MDSTooltipPlacement.Top,
        })}
      >
        <MDSButton
          variant={MDSButtonVariant.Subtle}
          size={MDSButtonSize.Small}
          onClick={() => {
            if (!note.id) return;

            onToggleOrganizeIsOpen();
          }}
        >
          <MDSIcon kind={MDSIconKind.Collection} slot={MDSButtonSlotName.LeftIcon} />
          Organize
        </MDSButton>
      </MDSTooltip>
    );

    return renderTrigger ? renderTrigger(organizeButton) : organizeButton;
  }
);
